import { User } from "reauthorize";

export interface CurrentUser extends User {
    id?: string;
    name: string;
    email?: string;
    unauthorizedDueToNoAssignedRoles?: boolean;
    isLocumUser?: boolean;
    locumUserFullName?: string;
}

export const isAdminUser = (user: { roles: string[] }) => Object.values(ADMIN_ROLES).some(r => user.roles.includes(r.name));

export const isCustomerUser = (user: { roles: string[] }) => Object.values(CUSTOMER_ROLES).some(r => user.roles.includes(r.name));

export const isSystemAdminUser = (user: { roles: string[] }) => user.roles.includes(ADMIN_ROLES.SYSTEM_ADMIN.name);

export const notCaseManagerRole = (role: string) => role !== "CASE_MANAGER";

export const notAdministratorRole = (role: string) => role !== "ADMINISTRATOR";

export const notAnySraRole = (role: string) => role !== "SRA_MANAGER" && role !== "SRA_DEPARTMENT_LEAD";

export const ADMIN_ROLES = {
    // The highest role in the system
    SYSTEM_ADMIN: { displayName: "System Administrator", name: "SystemAdmin" },
    // "SystemAdministrator" has been renamed at some point to "SeniorAdministrator"
    // Value itself hasn't been change to keep the current user credentials stored in the database
    SENIOR_ADMINISTRATOR: { displayName: "Senior Administrator", name: "SystemAdministrator" },
    ADMINISTRATOR: { displayName: "Administrator", name: "Administrator" },
    CLINICIAN: { displayName: "Clinician", name: "Clinician" },
    AMAZON_TECHNICIAN_ONLY: { displayName: "Amazon Technician Only", name: "AmazonTechnicianOnly" },
    QA_AUDITOR: { displayName: "Auditor", name: "QAAuditor" }
};

export const CUSTOMER_ROLES = {
    MANAGER: { displayName: "Manager", name: "Manager" },
    HR: { displayName: "HR", name: "Hr" },
    RECRUITMENT_MANAGER: { displayName: "Recruitment Manager", name: "RecruitmentManager" },
    ADMINISTRATOR: { displayName: "Administrator", name: "CustomerAdministrator" },
    CASE_MANAGER: { displayName: "Case Manager", name: "CaseManager" },
    SRA_MANAGER: { displayName: "SRA Manager", name: "SraManager" },
    SRA_DEPARTMENT_LEAD: { displayName: "SRA Department Lead", name: "SraDepartmentLead" },
    OTHER_SERVICES: { displayName: "Other Services", name: "OtherServices" }
};
